"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TagsSaveDto {
}
exports.TagsSaveDto = TagsSaveDto;
